import { FilterIcon } from "assets/icons";
import { SpinLoader } from "components";
import TicketCard from "components/ticketCard";

function Tickets({ loading, tripDate, searchResults, setOpenFilters }) {
  if (loading) {
    return (
      <div className="w-full flex flex-col items-center py-8">
        <SpinLoader />
      </div>
    );
  }

  if (!searchResults?.length) {
    return (
      <div className="w-full flex flex-col items-center py-8">
        <div className="text-[20px] leading-5 lg:text-2xl text-[#112211] font-semibold mb-2">
          No results found
        </div>
        <div className="text-sm text-[#858585] font-medium">
          We couldn't find what you searched for. Try searching again.
        </div>
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col">
      <div className="w-full flex items-center gap-2 mb-5">
        <div className="flex-1 flex flex-col">
          <div className="text-[20px] leading-5 lg:text-2xl text-[#112211] font-semibold mb-2 lg:mb-4">
            Available Bus
          </div>
          <div className="text-sm text-[#858585] font-medium">
            Select a ticket type
          </div>
        </div>
        <button
          onClick={() => setOpenFilters(true)}
          className="text-sm bg-black text-white py-2.5 px-6 rounded-lg flex items-center lg:hidden gap-2.5"
        >
          Filter <FilterIcon />
        </button>
      </div>
      <div className="w-full flex flex-col gap-8">
        {searchResults.map((bus, index) => (
          <TicketCard key={index} data={bus} tripDate={tripDate} />
        ))}
        {searchResults.length > 10 && (
          <button className="w-full h-[48px] bg-[#112211] text-sm text-white font-semibold rounded-[4px] flex items-center justify-center px-3">
            Show more results
          </button>
        )}
      </div>
    </div>
  );
}

export default Tickets;
